export const Language = {
  English: 'ENGLISH',
  Russian: 'RUSSIAN'
}
